/** @format */

// 参与者属性
export const partyTypeOptions = [
	{
		value: 'org',
		label: '组织',
	},
	{
		value: 'position',
		label: '岗位',
	},
	{
		value: 'role',
		label: '角色',
	},
	{
		value: 'group',
		label: '用户组',
	},
];
// 人员状态
export const statusOptions = [
	{
		value: 'actived',
		label: '已激活',
		type: 'success',
	},
	{
		value: 'inactive',
		label: '未激活',
		type: 'info',
	},
	{
		value: 'expired',
		label: '过期',
		type: 'danger',
	},
	{
		value: 'locked',
		label: '锁定',
		type: 'warning',
	},
	{
		value: 'disabled',
		label: '禁用',
		type: 'danger',
	},
];
// 性别
export const genderOptions = [
	{
		value: 'male',
		label: '先生',
	},
	{
		value: 'female',
		label: '女士',
		type: 'danger',
	},
];
export const isSuperOptions = [
	{
		value: 'Y',
		label: '是',
	},
	{
		value: 'N',
		label: '否',
		type: 'danger',
	},
];
